



















































import { SimulatorState } from '@/simulator';
import { SettingsState } from '@/utilities';
import { BModal } from 'bootstrap-vue';
import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      simulatorState: SimulatorState,
      settingsState: SettingsState,
    }
  },

  computed: {
    settings: SettingsState.settings,
    memSizes: () => SimulatorState.memory().sizes
  },

  methods: {
    show: function () {
      (this.$refs.modal as BModal).show();
    }
  },

  watch: {
    settings: {
      handler: function () {
        SettingsState.updateStorage();
      },
      deep: true
    }
  }
})
